import type { IProspect } from '../../../../stores/JobApplicationStore/CandidateStore';
import type { IEmail } from '../../../../stores/JobApplicationStore/Email';
import type { INote } from '../../../../stores/JobApplicationStore/Note';

const getTimeline = (previousApplication: IProspect) => {
  const items: Array<{
    type: 'email' | 'note';
    date: string;
    object: IEmail | INote;
  }> = [];
  previousApplication.prospectEmailStore.emailList.forEach((email) =>
    items.push({
      type: 'email',
      date: email.sentDate,
      object: email,
    }),
  );
  previousApplication.notes.noteList.forEach((note) =>
    items.push({
      type: 'note',
      date: note.createdDate,
      object: note,
    }),
  );

  items.sort((a, b) => b.date.localeCompare(a.date));

  return items;
};

export default getTimeline;
